import React from "react";
import { CmsImageSlideshow as CmsImage } from "../lib/images";

/**
 * Hero banner — single full-bleed brand image.
 * No carousel, no slides, no captions — just the client's banner artwork
 * fading cleanly into the navbar above and the rest of the page below.
 */
export default function HeroBanner() {
  return (
    <section
      className="relative w-full overflow-hidden aspect-[4/3] sm:aspect-auto sm:h-[65vh] md:h-[75vh] sm:min-h-[460px] sm:max-h-[720px] mt-[84px] sm:mt-0 sm:pt-24 bg-[#06080D]"
      data-testid="hero-banner"
    >
      <CmsImage
        slotKey="home.hero"
        defaultSrc="/xega-banner.jpg"
        alt=""
        aria-hidden="true"
        width="2400"
        height="1340"
        loading="eager"
        decoding="async"
        fetchPriority="high"
        className="absolute inset-0 w-full h-full object-cover sm:object-cover object-center"
      />

      {/* Cinematic top/bottom fades to integrate with navbar above and content below */}
      <div className="absolute top-0 left-0 right-0 h-20 sm:h-28 bg-gradient-to-b from-[#06080D] via-[#06080D]/70 to-transparent pointer-events-none" />
      <div className="hidden sm:block absolute bottom-0 left-0 right-0 h-24 sm:h-28 bg-gradient-to-b from-transparent via-[#06080D]/70 to-[#06080D] pointer-events-none" />

      {/* Subtle grid + noise overlays */}
      <div className="absolute inset-0 grid-bg opacity-15 pointer-events-none" />
      <div className="absolute inset-0 noise-overlay opacity-60 pointer-events-none" />
    </section>
  );
}
